import { render, staticRenderFns } from "./growthModelHisParamControl.vue?vue&type=template&id=1c22a5f5&scoped=true"
import script from "./growthModelHisParamControl.vue?vue&type=script&lang=js"
export * from "./growthModelHisParamControl.vue?vue&type=script&lang=js"
import style0 from "./growthModelHisParamControl.vue?vue&type=style&index=0&id=1c22a5f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22a5f5",
  null
  
)

export default component.exports